import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { patientAvailabilities } from '../mockData/patient-availabilities-data';

const PatientAvailabilitiesApi = [
  rest.get(`${API_ROOT}patient-availabilities`, (req, res, ctx) => res(ctx.json(patientAvailabilities))),
  rest.get(`${API_ROOT}patient-availabilities/${patientAvailabilities[0].id}`, (req, res, ctx) => res(ctx.json(patientAvailabilities[0]))),
  rest.put(`${API_ROOT}patient-availabilities/${patientAvailabilities[0].id}`, (req, res, ctx) => res(ctx.json(patientAvailabilities[0]))),
  rest.post(`${API_ROOT}patient-availabilities`, (req, res, ctx) => res(ctx.json(patientAvailabilities[1]))),
  rest.delete(`${API_ROOT}patient-availabilities/${patientAvailabilities[0].id}`, (req, res, ctx) => res(ctx.json(patientAvailabilities[0]))),
];

export default PatientAvailabilitiesApi;
